import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {TweenMax, Power3} from 'gsap';
import PageHero from 'components/page/page-hero';
import PageContent from 'components/page/page-content';
import PageLoader from 'components/page/page-loader';

export default class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    const $pageTexture = Array.from(document.querySelectorAll('.js-page-texture-bg'));

    $pageTexture.forEach($texture => {
      TweenMax.to($texture, 0.33, {
        'opacity': 1
      });
    });
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately before mounting occurs. It is called before
   * render(), therefore setting state synchronously in this method will not
   * trigger a re-rendering.
   *
   * @method  componentWillMount
   */
  componentWillMount() {
    window.scrollTo(0, 0);
    document.title = `${this.props.title} | Ret\u00FCl Passport`;
  }

  _renderMainContent() {
    return (
      !this.props.children ? '' : (
        <PageContent mainClasses={this.props.mainClasses}>
          {this.props.children}
        </PageContent>
      )
    )
  }

  _renderPageFullTexture() {
    return (
      this.props.fullTexture ? (
        <div className="page-texture-bg js-page-texture-bg"></div>
      ) : ''
    )
  }

  _renderPageLoader() {
    return this.props.isLoading === undefined ? '' : (
      <PageLoader
        isLoading={this.props.isLoading}
        fixedLoader={this.props.fixedLoader}
      />
    )
  }

  render() {
    const pageClasses = classNames('page', {
      'page_fullTexture': this.props.fullTexture
    });
    const textureClasses = classNames('page-texture', {
      'page-texture_plain': this.props.fullTexture
    });
    const mainContent = this._renderMainContent();
    const pageFullTexture = this._renderPageFullTexture();
    const pageLoader = this._renderPageLoader();

    return (
      <div className={pageClasses}>
        {pageLoader}
        {pageFullTexture}
        <div className={textureClasses}>
          <div className="page-texture-bg js-page-texture-bg"></div>
          <PageHero hero={this.props.pageHero} />
        </div>
        {mainContent}
      </div>
    )
  }
}

Page.propTypes = {
  'fixedLoader': PropTypes.bool,
  'fullTexture': PropTypes.bool,
  'isLoading': PropTypes.bool,
  'mainClasses': PropTypes.string,
  'pageHero': PropTypes.node,
  'title': PropTypes.string
};



// WEBPACK FOOTER //
// ./src/client/components/page/page.jsx